const  DataBlog =[
    {
      "name": "Ароматные Брускетты",
      "image": "https://avatars.mds.yandex.net/i?id=40e5b061a9fc5b8f21399ace47f55eb9-5598230-images-thumbs&n=13",
      "price": 12000,
      "id": "aromatnye-bruskety"
    },
    {
      "name": "Карибские Креветки в Коктейльном Соусе",
      "image": "https://avatars.mds.yandex.net/i?id=26d05b18cd936d0fee4e18bcdbe918bf60d687f7-9820447-images-thumbs&n=13",
      "price": 22000,
      "id": "karibskie-krevetki-v-koktejlnom-souse"
    },
    {
      "name": "Фета-Роллы с Оливками",
      "image": "https://avatars.mds.yandex.net/i?id=bcdf2ecc710e16a36ad6c6453fb1033bddeefd22-10087650-images-thumbs&n=13",
      "price": 16000,
      "id": "feta-rolly-s-olivkami"
    },
    {
      "name": "Карамельные Куриные Крылышки",
      "image": "https://avatars.mds.yandex.net/i?id=26a636371a38fd06a64ea93f21e5b586b0ebe907-12525650-images-thumbs&n=13",
      "price": 18000,
      "id": "karamelnye-kurinye-krylishki"
    },
    {
      "name": "Лососевые Блинчики с Тартаром",
      "image": "https://avatars.mds.yandex.net/i?id=34f3d9b81ab4a0a43f394d55172b8328c28ece25-10639206-images-thumbs&n=13",
      "price": 25000,
      "id": "lososyevoe-blinchiki-s-tartarom"
    },
    {
      "name": "Жареный Кальмар с Лимоном и Чесночным Соусом",
      "image": "https://avatars.mds.yandex.net/i?id=0531f76f564e9787c855f424a45e3f000dc11660-9182224-images-thumbs&n=13",
      "price": 20000,
      "id": "zharenyj-kalmar-s-limonom-i-chesnochnym-sousom"
    },
    {
      "name": "Креветки с Гуакамоле и Чипсами",
      "image": "https://avatars.mds.yandex.net/i?id=fb14d9076c24ad961d928a9b426785c6d48e35b1-10471591-images-thumbs&n=13",
      "price": 26000,
      "id": "krevetki-s-guakamole-i-chipsami"
    },
    {
      "name": "Шпинатные и Фета Канапе",
      "image": "https://avatars.mds.yandex.net/i?id=1f0c411787868649c6cbd6ac1363e384cc2a2c89-9106968-images-thumbs&n=13",
      "price": 14000,
      "id": "shpinatniye-i-feta-kanape"
    },
    {
      "name": "Красные Фаршированные Перчики с Чесноком",
      "image": "https://avatars.mds.yandex.net/i?id=070c6d6888ca23a5278435b19f886a3f4f9dbd59-10967292-images-thumbs&n=13",
      "price": 17000,
      "id": "krasniye-farshirovanniye-perchiki-s-chernikom"
    },
    {
      "name": "Мини-Кесадильи с Цыпленком и Сыром",
      "image": "https://avatars.mds.yandex.net/i?id=3d06ebea261c9a047897500dbaaf8e8ab346f128-10414364-images-thumbs&n=13",
      "price": 21000,
      "id": "mini-kesadilli-s-tsyplyenkom-i-syrom"
    },
    {
      "name": "Овощные Рулетики с Черничным Соусом",
      "image": "https://avatars.mds.yandex.net/i?id=9b0be5688a50aac7a8dc195d1bdcaaaf3158b9d7-5233604-images-thumbs&n=13",
      "price": 15000,
      "id": "ovoshchnye-ruletiki-s-chernichnym-sousom"
    },
    {
      "name": "Картофельные Дольки с Трюфельным Маслом",
      "image": "https://avatars.mds.yandex.net/i?id=745c209d5a3fa8306c8eaed010db7555df1d5504-10639206-images-thumbs&n=13",
      "price": 19000,
      "id": "kartofelnye-dolki-s-tryufelnym-maslom"
    }
  ]
  
  export default DataBlog